import { render, staticRenderFns } from "./crp-customer-list.vue?vue&type=template&id=7042446a&scoped=true"
import script from "./crp-customer-list.vue?vue&type=script&lang=js"
export * from "./crp-customer-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042446a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7042446a')) {
      api.createRecord('7042446a', component.options)
    } else {
      api.reload('7042446a', component.options)
    }
    module.hot.accept("./crp-customer-list.vue?vue&type=template&id=7042446a&scoped=true", function () {
      api.rerender('7042446a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/admin/crp-customer-list.vue"
export default component.exports